import template from './attachmentsListItem.template.html';

export default {
  template,
  bindings: {
    attachment: '<',
    accounts: '<',
    contacts: '<',
    partners: '<',
    labels: '<',
    showsInAll: '<',
    isCombinePdfSelected: '<',
    onRequestSignature: '&',
    onShareClient: '&',
    onSharePartner: '&',
    onLock: '&',
    onPin: '&',
    onDownload: '&',
    onDownloadPdf: '&',
    onRename: '&',
    onRedactTfn: '&',
    onPreview: '&',
    onLabelsSelect: '&',
    onDelete: '&',
    onChange: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, DOCUMENT, FILE) {
      'ngInject';

      const ctrl = this;
      ctrl.isDev = false;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.$mdMedia = $mdMedia;

      ctrl.initialize = () => {
        ctrl.isDev = $rootScope.isDev();
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentAccount = $rootScope.CurrentAccount;
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.attachment = ctrl.attachment || {};
        ctrl.accounts = ctrl.accounts || [];
        ctrl.contacts = ctrl.contacts ? ctrl.contacts : [];
        ctrl.partners = ctrl.partners ? ctrl.partners : [];
        ctrl.labels = ctrl.labels || [];
        ctrl.showsInAll = ctrl.showsInAll || false;
        ctrl.isCombinePdfSelected = ctrl.isCombinePdfSelected || false;
        ctrl.acceptableFileExtensions = FILE.ACCEPTABLE_FILE_EXTENSIONS;
      };

      ctrl.select = (data) => {
        ctrl.onChange({ data });
      };

      ctrl.attachmentPin = ($event, data) => {
        ctrl.onPin({ event: $event, data });
      };

      ctrl.attachmentLock = ($event, data) => {
        ctrl.onLock({ event: $event, data });
      };

      ctrl.attachmentRequestSignature = ($event, data, type, isNonEmbedded) => {
        ctrl.onRequestSignature({ event: $event, data, type, isNonEmbedded });
      };

      ctrl.attachmentShareClient = ($event, data) => {
        ctrl.onShareClient({ event: $event, data });
      };

      ctrl.attachmentSharePartner = ($event, data) => {
        ctrl.onSharePartner({ event: $event, data });
      };

      ctrl.attachmentDownload = ($event, data) => {
        ctrl.onDownload({ event: $event, data });
      };

      ctrl.attachmentDownloadPdf = ($event, data) => {
        ctrl.onDownloadPdf({ event: $event, data });
      };

      ctrl.attachmentRename = ($event, data) => {
        ctrl.onRename({ event: $event, data });
      };

      ctrl.attachmentRedactTFN = ($event, data) => {
        ctrl.onRedactTfn({ event: $event, data });
      };

      ctrl.attachmentPreview = ($event, data) => {
        ctrl.onPreview({ event: $event, data });
      };

      ctrl.attachmentLabelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.attachmentDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.canOpenPreview = () =>
        _.indexOf(
          ctrl.acceptableFileExtensions || [],
          ctrl.attachment?.getFileExtension()?.toLowerCase()
        ) > -1;

      ctrl.canSelect = () => {
        if (ctrl.isCombinePdfSelected) {
          return (
            ctrl.attachment?.getFileExtension()?.toLowerCase() === 'pdf' &&
            !ctrl.attachment?.isLocked
          );
        }
        return !ctrl.attachment?.isLocked;
      };

      ctrl.canDownloadPdf = () =>
        DOCUMENT.DOWNLOAD_DOCUMENT_AS_PDF.indexOf(ctrl.attachment.getFileExtension()) > -1;

      ctrl.getLabel = (idLabel) => _.find(ctrl.labels, (l) => l.id === idLabel);

      ctrl.getAccount = (idAccount) => _.find(ctrl.accounts, (a) => a.id === idAccount);

      ctrl.getContact = (idContact) => _.find(ctrl.contacts, (c) => c.id === idContact);

      ctrl.getPartner = (idPartner) => _.find(ctrl.partners, (c) => c.id === idPartner);

      ctrl.getOwner = () => {
        let owner = null;
        if (ctrl.attachment.idOwnerContact || ctrl.attachment.idOwnerPartner) {
          if (ctrl.attachment.idOwnerContact) {
            owner = ctrl.getContact(ctrl.attachment.idOwnerContact);
          }
          if (ctrl.attachment.idOwnerPartner) {
            owner = ctrl.getPartner(ctrl.attachment.idOwnerPartner);
          }
        } else {
          owner = ctrl.getAccount(ctrl.attachment.idOwner);
        }
        return owner;
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes?.attachments?.currentValue || changes?.isCombinePdfSelected?.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
